module.exports = __webpack_public_path__ + "media/images/riders/TROY_BROSNAN-6db41afe83c8e8951ea7b94b468b3b46.png";